import { lazy } from 'react';
import WidgetCategory from '../../WidgetCategory';

export default class BBIFCJSViewerDescriptor{


static getDescription() {
    return {
      name: 'IFCJSViewer',
      //component: lazy(() =>  import('./BBIFCJSViewer.js')),
      component: lazy(() =>  import('./BBIFCViewer.js')),
      label: 'IFC JS Viewer (v2) (deprecated)',
      category: WidgetCategory.deprecated,
      variables: [
        {
          name: 'query',
          type: 'yasgui',
          label: 'use parameter ?filename ?guid ?hidden ?alpha ?color  ',
        }]
    }
}
}